export const UNPAID_PAYMENTS_PARENT = 'UnpaidPaymentsV2ParentComponent';

export const UNPAID_PAYMENTS_PRODUCT_COMPONENTS = new Set([
  'UnpaidPaymentsLendeeComponent',
  'UnpaidPaymentsDenefitsComponent',
  'UnpaidPaymentsCredeeComponent',
  'UnpaidPaymentsRecuveryComponent',
  'UnpaidPaymentsFmComponent',
]);

export const UNPAID_PAYMENTS_COMPONENT_TO_PRODUCT_KEY: Record<string, string> = {
  UnpaidPaymentsDenefitsComponent: 'denefits',
  UnpaidPaymentsCredeeComponent: 'credee',
  UnpaidPaymentsLendeeComponent: 'lendee',
  UnpaidPaymentsRecuveryComponent: 'recuvery',
  UnpaidPaymentsFmComponent: 'fm',
};

export const UNPAID_PAYMENTS_COMPONENTS = new Set([
  UNPAID_PAYMENTS_PARENT,
  'UnpaidPaymentsOverviewStubComponent',
  ...UNPAID_PAYMENTS_PRODUCT_COMPONENTS,
]);

export function isUnpaidPaymentsProductComponent(name: string): boolean {
  return UNPAID_PAYMENTS_PRODUCT_COMPONENTS.has(name);
}

export function isUnpaidPaymentsRoute(componentName: string): boolean {
  return UNPAID_PAYMENTS_COMPONENTS.has(componentName);
}

export function productKeyForUnpaidPaymentsComponent(componentName: string): string | null {
  return UNPAID_PAYMENTS_COMPONENT_TO_PRODUCT_KEY[componentName] ?? null;
}

const ALL_UNPAID_PRODUCT_ROUTE_KEYS = new Set(
  Object.values(UNPAID_PAYMENTS_COMPONENT_TO_PRODUCT_KEY)
);

/** Product keys whose unpaid-payments child route exists in `sessionStorage.dynamic_routes`. */
export function readUnpaidPaymentsRouteProductKeys(): ReadonlySet<string> {
  if (typeof sessionStorage === 'undefined') {
    return ALL_UNPAID_PRODUCT_ROUTE_KEYS;
  }

  try {
    const raw = sessionStorage.getItem('dynamic_routes');
    if (!raw) {
      return ALL_UNPAID_PRODUCT_ROUTE_KEYS;
    }

    const products = JSON.parse(raw);
    if (!Array.isArray(products)) {
      return ALL_UNPAID_PRODUCT_ROUTE_KEYS;
    }

    const available = new Set<string>();
    let foundUnpaidSection = false;

    for (const productEntry of products) {
      const routes = productEntry?.routes;
      if (!Array.isArray(routes)) {
        continue;
      }

      for (const route of routes) {
        const subMenus = route?.subMenus;
        if (!Array.isArray(subMenus)) {
          continue;
        }

        const hasUnpaidParent =
          route?.componentName === UNPAID_PAYMENTS_PARENT ||
          subMenus.some((sub: { componentName?: string }) =>
            isUnpaidPaymentsProductComponent(sub?.componentName ?? '')
          );

        if (!hasUnpaidParent) {
          continue;
        }

        foundUnpaidSection = true;

        for (const sub of subMenus) {
          const productKey = productKeyForUnpaidPaymentsComponent(sub?.componentName ?? '');
          if (productKey) {
            available.add(productKey);
          }
        }
      }
    }

    return foundUnpaidSection ? available : ALL_UNPAID_PRODUCT_ROUTE_KEYS;
  } catch {
    return ALL_UNPAID_PRODUCT_ROUTE_KEYS;
  }
}

export function isUnpaidPaymentsProductRouteAvailable(productKey: string): boolean {
  return readUnpaidPaymentsRouteProductKeys().has(productKey);
}
